export const AIRWALLEX_COMPONENTS_THEME = {
  palette: {
    primary: {
      '5': '#00e6ff',
      '10': '#00cfe5',
      '20': '#00b8cc',
      '30': '#00a1b3',
      '40': '#008a99',
      '50': '#007380',
      '60': '#005c66',
      '70': '#002e33',
      '80': '#000',
      '90': '#000',
      '100': '#000',
    },
    secondary: {
      '5': '#fff',
      '10': '#fff',
      '20': '#fff',
      '30': '#fff',
      '40': '#fff',
      '50': '#fff',
      '60': '#fff',
      '70': '#ffffff',
      '80': '#e6e6e6',
      '90': '#ccc',
      '100': '#b3b3b3',
    },
    success: {
      '5': '#ade4cc',
      '10': '#99ddc1',
      '20': '#86d7b5',
      '30': '#73d0a9',
      '40': '#60ca9e',
      '50': '#4dc492',
      '60': '#3eb986',
      '70': '#31936a',
      '80': '#246d4e',
      '90': '#174633',
      '100': '#0b2017',
    },
    error: {
      '5': '#f4e5e4',
      '10': '#edd3d1',
      '20': '#e6c1bf',
      '30': '#dfb0ac',
      '40': '#d89e9a',
      '50': '#d18c87',
      '60': '#ca7a75',
      '70': '#bc5750',
      '80': '#9d423c',
      '90': '#78332e',
      '100': '#532320',
    },
    informational: {
      '5': '#f7fbfe',
      '10': '#e1f2fb',
      '20': '#cbe8f7',
      '30': '#b4def4',
      '40': '#9ed4f1',
      '50': '#88caee',
      '60': '#72c0ea',
      '70': '#45ace4',
      '80': '#1f96d7',
      '90': '#1977aa',
      '100': '#12587e',
    },
    warning: {
      '5': '#fef4e0',
      '10': '#feebc7',
      '20': '#fde1ae',
      '30': '#fdd895',
      '40': '#fccf7c',
      '50': '#fcc663',
      '60': '#fbbd4a',
      '70': '#faab18',
      '80': '#da9005',
      '90': '#a86f04',
      '100': '#764e03',
    },
  },
  typography: {
    fontFace: {
      cssFontSource:
        'https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap',
    },
    fontFamily: 'Instrument Sans',
  },
  components: {
    spinner: {
      colors: { stop: { initial: '#b3b3b3' }, start: { initial: '#bfbfbf' } },
    },
    button: {
      colors: {
        secondary: {
          background: { hover: '#f2f2f2', active: '#f2f2f2', focus: '#f2f2f2' },
          boxShadow: '#002e33',
        },
        danger: { background: { initial: '#bc5750' } },
        success: { background: { initial: '#002e33' } },
        link: {
          background: { active: '#45ace4', hover: '#3078a0' },
          foreground: { initial: '#1a1d21' },
        },
      },
    },
    select: {
      colors: {
        controlBackground: { initial: '#fcfcfd', disabled: '#f6f7f8' },
        indicator: { initial: '#545b63' },
        placeholder: { initial: '#868e98', selected: '#1a1d21' },
        option: { initial: '#42474d' },
        optionBackground: { focus: '#e9f8f8', active: '#e9f8f8' },
      },
    },
    alert: {
      colors: {
        background: {
          success: '#effbf3',
          informational: '#f0f9ff',
          warning: '#fffbef',
          critical: '#ffefef',
        },
        iconBackground: { informational: '#45ace4', warning: '#faab18' },
        border: {
          informational: '#f0f9ff',
          success: '#effbf3',
          warning: '#fffbef',
          critical: '#ffefef',
        },
        link: { text: { initial: '#1a1d21', active: '#2f3237' } },
      },
    },
  },
}
